import { Component, OnInit } from "@angular/core"

@Component({
  selector: "app-page-not-found",
  templateUrl: "./page-not-found.component.html",
  styleUrls: ["./page-not-found.component.scss"]
})
export class PageNotFoundComponent implements OnInit {
  constructor() {}

  // @todo should use import so this doesn't break the testing
  ngOnInit() {
    window.location.href = "https://onelocal.com/local-referrals"
  }
}



// WEBPACK FOOTER //
// /home/runner/work/onelocal/onelocal/src/my-referral/src/app/page-not-found/page-not-found.component.ts